import script from "./Caption.vue?vue&type=script&setup=true&lang=ts"
export * from "./Caption.vue?vue&type=script&setup=true&lang=ts"

import "./Caption.vue?vue&type=style&index=0&id=d42539ba&scoped=true&lang=css"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d42539ba"]])

export default __exports__